import { FC } from 'react';
import Button from '../../components/Button/Button';
import { Variant } from '../../components/Button/Button.types';
import Modal from '../../components/Modal/Modal';
import { Buttons, Message } from '../TwoButtonModal/TwoButtonModal.styles';
import { DeleteConfirmationModalProps } from './DeleteConfirmationModal.types';
import Table from '../../components/Table/Table';
import rem from '../../utils/rem/rem';

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({ onDelete, open, onClose, isLoading, confirmBtnTestId, cancelBtnTestId,
title = 'Are you sure you want to delete?', message = 'This action cannot be undone.', label = 'Delete', rowData = [], columnDef , messageMarginBottom = 56, modalBodyWidth}) => (
  <Modal id='deleteConfirmationModal' open={open} title={title} onClose={onClose} bodyWidth={modalBodyWidth}>
    <div data-testid='deleteConfirmationModal'>
      <Message style={{'marginBottom': rem(messageMarginBottom)}}>{message}</Message>
      {rowData.length > 0 && columnDef &&
        <div style={{'marginBottom': rem(12)}}>
          <Table
            height={'340px'}
            rowData={rowData}
            returnedRecords={rowData.length}
            columnDefs={columnDef}
            isSizeColumnsToFit={false}
          />
        </div>
      }
      <Buttons>
        <Button testId={cancelBtnTestId} variant={Variant.Secondary} label='Cancel' onClick={onClose} />
        <Button
          variant={Variant.Primary}
          label={label}
          onClick={onDelete}
          testId={confirmBtnTestId}
          isLoading={isLoading}
          loadingLabel='Deleting...'
        />
      </Buttons>
    </div>
  </Modal>
);

export default DeleteConfirmationModal;
